import React from 'react';
import classNames from 'classnames';
import { debounce } from 'lodash';

import './DownloadModalButton.scss';

const preventDoubleCLickDebounceTime = 500;

interface DownloadModalButtonProps {
  id: string;
  buttonText: string;
  buttonIcon: string;
  onClick: () => void;
  disabled?: boolean;
  selected?: boolean;
}

const DownloadModalButton = ({
  id,
  buttonText,
  buttonIcon,
  onClick,
  disabled = false,
  selected = false,
}: DownloadModalButtonProps) => (
  <button
    type='button'
    id={id}
    disabled={disabled}
    aria-pressed={selected}
    className={classNames('download-modal-button', {
      'download-modal-button--selected': selected,
    })}
    onClick={debounce(onClick, preventDoubleCLickDebounceTime, {
      leading: true,
      trailing: false,
    })}
  >
    <span className='download-modal-button__text'>{buttonText}</span>
    <img
      className='download-modal-button__icon'
      src={buttonIcon}
      alt={buttonIcon}
    />
  </button>
);

export default DownloadModalButton;
